import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-07-14T14:28:50-0400.
 */
export function useWorkOrdersServiceRequestInvoicingOptionsEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.WorkOrdersServiceRequestInvoicingOptions,
    false
  );

  return Boolean(isEnabled);
}
